<template>
  <div class="component">
    <vue-headful
    title="themes List | W&S Docs"
    />
    <div class="loading" v-if="loading">
      <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div class="alert alert-success text-success font-weight-bold" role="alert" v-if="result">
      Успешно удалено!
    </div>

    <div class="form-group">
      <router-link class="btn bg-dark text-white" to="/admin/themes/add">Добавить тему</router-link>
    </div>

    <ul class="list-group list-group-flush">
      <li :key="index"
      class="list-group-item bg-dark d-flex align-items-center justify-content-between" v-for="(theme, index) in AllThemesGet">
      <div class="form-group m-0">
        <router-link :to="'/methods/' +  theme.theme_link">{{ theme.theme_link }}</router-link>
      </div>
      <div class="form-group m-0">
        <router-link :to="'/admin/themes/edit/' + theme.theme_link" class="btn p-1" title="Edit">
          <i class="far fa-edit"></i>
        </router-link>
        <span @click="deleteTheme(index, theme.theme_id)" class="btn p-1" title="Delete">
          <i class="fas fa-times-circle"></i>
        </span>
      </div>
    </li>
  </ul>
</div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: "themesList",
    data() {
      return {
        loading: true,
        result: false
      }
    },
    computed: mapGetters(['AllThemesGet', 'ThemeErrorGet', 'ThemeSuccessGet', 'AdminAuthInfoGet']),
    mounted() {
      this.$store.dispatch('AllThemesAct');
      this.loading = false;
    },
    methods: {
      deleteTheme: function (index, theme_id) {
        let AdminID = this.AdminAuthInfoGet.AdminID,
        AdminToken = this.AdminAuthInfoGet.AdminToken;

        this.$store.dispatch('ThemeStatusAct', [theme_id, 1, AdminID, AdminToken]);

        if (this.ThemeSuccessGet === true && this.ThemeErrorGet.length === 0) {
          this.result = true;
          this.$store.dispatch('AllThemesAct');
          this.$store.getters.AllThemesGet;
        }
      },
    }
  }
</script>

<style scoped>

</style>
